
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/submission/[id]",
      function () {
        return require("private-next-pages/submission/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/submission/[id]"])
      });
    }
  